import cx from 'classnames';

import { RiskKeys } from '@/config';
import { getSignalTranslation, getRiskGroupBySignal } from '@/helpers';
import { Pill } from '@/components';

import styles from './SignalBadge.module.sass';

interface SignalBadgeProps {
  isTextOnly?: boolean;
  value?: RiskKeys | null;
  className?: string;
}

const SignalBadge = ({ isTextOnly, value, className }: SignalBadgeProps) => {
  if (value == null || value === '') {
    return null;
  }
  const riskGroup = getRiskGroupBySignal(value);
  const label = getSignalTranslation(value);

  const classes = cx(
    styles.signal,
    styles[`signal--${riskGroup}`],
    {
      [styles['is-text-only']]: isTextOnly,
    },
    className,
  );

  return <Pill text={label} tooltipText={label} className={classes} />;
};

export default SignalBadge;
